import {
  ApiResultDTO,
  CompanyTypes,
  CompleteDealerRegistrationDTO,
  DealerAddressInfoDTO,
  DealerChainGroupDTO,
  DealerClient_V1,
  DealerLocationDTO,
  DealerUserDTO,
  EditDealerUserDTO,
  ForgotPasswordDTO,
  InviteDealerUserDTO,
  PaginationBaseRequestDTO,
  UserDealerLocationsDTO
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';
import { ApiHelper } from 'src/utils';

export default class DealerService {
  private readonly _dealerClient: DealerClient_V1;

  constructor() {
    this._dealerClient = new DealerClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
  }

  public GetAllDealerUsers(dto: PaginationBaseRequestDTO): Promise<Array<DealerUserDTO>> {
    return this._dealerClient.getAllDealerUsers(dto);
  }

  public DealerUsers(dealerAccountUid: string, dto: PaginationBaseRequestDTO): Promise<Array<DealerUserDTO>> {
    return this._dealerClient.dealerUsers(dealerAccountUid, dto);
  }

  public CompanyLocations(): Promise<Array<DealerLocationDTO>> {
    return this._dealerClient.locationsByCompany();
  }

  public Locations(): Promise<Array<DealerLocationDTO>> {
    return this._dealerClient.locations();
  }

  public ChainGroups(): Promise<Array<DealerChainGroupDTO>> {
    return this._dealerClient.chainGroups();
  }

  public InviteDealerAdmin(dto: InviteDealerUserDTO): Promise<InviteDealerUserDTO> {
    return ApiHelper.ParseDTO<InviteDealerUserDTO>(() => this._dealerClient.inviteAdmin(dto));
  }

  public InviteDealerUser(dealerAccountUid: string, dto: InviteDealerUserDTO): Promise<InviteDealerUserDTO> {
    return ApiHelper.ParseDTO<InviteDealerUserDTO>(() => this._dealerClient.inviteUser(dto, dealerAccountUid));
  }

  public CompleteDealerRegistration(dto: CompleteDealerRegistrationDTO): Promise<CompleteDealerRegistrationDTO> {
    return ApiHelper.ParseDTO<CompleteDealerRegistrationDTO>(() => this._dealerClient.completeDealerInvite(dto));
  }

  public SendDealerAdminInvite(userId: string): Promise<ApiResultDTO> {
    return ApiHelper.ParseDTO<ApiResultDTO>(() => this._dealerClient.sendDealerAdminInvite(userId));
  }

  public SendDealerUserInvite(userId: string, dealerAccountUid: string): Promise<ApiResultDTO> {
    return ApiHelper.ParseDTO<ApiResultDTO>(() => this._dealerClient.sendDealerUserInvite(userId, dealerAccountUid));
  }

  public RemoveDealerAdminAccess(userId: string): Promise<ApiResultDTO> {
    return ApiHelper.ParseDTO<ApiResultDTO>(() => this._dealerClient.dealerAdmin(userId));
  }
  public RemoveDealerUserAccess(userId: string, dealerAccountId: string): Promise<ApiResultDTO> {
    return ApiHelper.ParseDTO<ApiResultDTO>(() => this._dealerClient.dealerUser(userId, dealerAccountId));
  }
  public EditDealerAdminAccess(dto: EditDealerUserDTO): Promise<ApiResultDTO> {
    return ApiHelper.ParseDTO<ApiResultDTO>(() => this._dealerClient.editDealerAdmin(dto));
  }
  public EditDealerUserAccess(dto: EditDealerUserDTO, dealerAccountUid: string): Promise<ApiResultDTO> {
    return ApiHelper.ParseDTO<ApiResultDTO>(() => this._dealerClient.editDealerUser(dto, dealerAccountUid));
  }
  public DealerAddressInfo(dynamicsLocationId: string): Promise<Array<DealerAddressInfoDTO>> {
    return this._dealerClient.dealerAddresInfo(dynamicsLocationId);
  }
  public UserDealerLocations(): Promise<UserDealerLocationsDTO> {
    return this._dealerClient.userDealerLocations();
  }
  public ForgotPassword(email: string): Promise<ForgotPasswordDTO> {
    const dto = new ForgotPasswordDTO();
    dto.email = email;
    dto.companyType = CompanyTypes.Dealer;

    return ApiHelper.ParseDTO<ForgotPasswordDTO>(() => this._dealerClient.forgotPassword(dto));
  }
}
